/* eslint-disable */ import { assertNumber, attributeSelectionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const legsWithOffsetComponents = [
    attachComponent.withComponent(attributeSelectionComponent, 'legOffset', true).withAlias('LegsWithOffset').attach(memoEval((self)=>[
            self.legOffset,
            self.$legOffsetOptions
        ], (legOffset, $legOffsetOptions)=>({
            value: legOffset,
            options: $legOffsetOptions
        })), (state)=>{
        assertNumber(state.value);
        return {
            legOffset: state.value
        };
    })
];

//# sourceMappingURL=legs-with-offset.js.map